import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { decodeTokenPayload } from '@/utils/czTokenUtils';

export function useCzAuth() {
  const router = useRouter();
  const { t: qT, c: qC, token: qToken } = router.query;

  const tokenStr = typeof qToken === 'string' ? qToken : null;
  const decoded = tokenStr ? decodeTokenPayload(tokenStr) : null;
  const t = decoded?.tenantId ?? qT;
  const c = decoded?.customerId ?? qC;

  useEffect(() => {
    if (!tokenStr || typeof sessionStorage === 'undefined') return;
    sessionStorage.setItem('czToken', tokenStr);
  }, [tokenStr]);

  return { t, c, tokenStr, customerName: decoded?.customerName ?? null };
}
